import { ModuleDeviceRequirements } from "features/module/types";

export const DEVICE_REQUIREMENTS: ModuleDeviceRequirements = {
  minModuleWidth: 920,
  desktopOnly: false
};

export const boundary = {
  x: 200,
  y: 100
};
